export class User {
  constructor() {}

  userInfo = async () => {
    let response = await fetch("api/user", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  dataChange = async (name_1, name_2, name_3, dob, sex) => {
    let form = new URLSearchParams();
    form.append("name_1", name_1);
    form.append("name_2", name_2);
    form.append("name_3", name_3);
    form.append("dob", dob);
    form.append("sex", sex);

    let response = await fetch("api/user", {
      method: "PUT",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  changePassword = async (
    password_current,
    password,
    password_confirmation
  ) => {
    let form = new URLSearchParams();
    form.append("password_current", password_current);
    form.append("password", password);
    form.append("password_confirmation", password_confirmation);

    let response = await fetch("api/user/password", {
      method: "PUT",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  agreement = async (agree_personal, agree_processing, agree_adv) => {
    let form = new URLSearchParams();
    form.append("agree_personal", agree_personal);
    form.append("agree_processing", agree_processing);
    form.append("agree_adv", agree_adv);

    let response = await fetch(`api/user/agreement`, {
      method: "PUT",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  userNews = async () => {
    let response = await fetch("api/user/news", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  signOut = async () => {
    let response = await fetch("api/signout", {
      method: "POST",
      credentials: "include",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  forgotPassword = async (card_id, user_id, token) => {
    let response = await fetch(
      `/api/forgot/${card_id}/check-and-update?user_id=${user_id}&token=${token}&method=email`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
        cache: "no-store",
      }
    );
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };
}

export class Cards {
  constructor() {}

  userCard = async () => {
    let response = await fetch("api/cards", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  card = async (id) => {
    let response = await fetch(`api/cards/${id}`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  subscriptions = async (id) => {
    let response = await fetch(`api/cards/${id}/subscriptions`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  deleteSubscription = async (card_id, billing_service_code) => {
    let response = await fetch(
      `api/cards/${card_id}/subscriptions/${billing_service_code}`,
      {
        method: "DELETE",
      }
    );
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  connectSubscription = async (card_id, billing_service_code) => {
    let form = new URLSearchParams();
    form.append("billing_service_code", billing_service_code);

    let response = await fetch(`api/cards/${card_id}/subscriptions`, {
      method: "POST",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  activeSubscriptions = async (card_id) => {
    let response = await fetch(`api/cards/${card_id}/subscriptions/active`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  balance = async (card_id) => {
    let response = await fetch(`api/cards/${card_id}/balance`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  payments = async (card_id) => {
    let response = await fetch(`api/cards/${card_id}/payments`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  restart = async (id) => {
    let response = await fetch(`api/cards/${id}/restart`, {
      method: "POST",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  actions = async (id) => {
    let response = await fetch(`api/cards/${id}/actions`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  actionActivation = async (card_id, action_id, active) => {
    let form = new URLSearchParams();
    form.append("active", active);

    let response = await fetch(`api/cards/${card_id}/actions/${action_id}`, {
      method: "POST",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  recurrent = async (id, status) => {
    let form = new URLSearchParams();
    form.append("status", status);

    let response = await fetch(`api/cards/${id}/recurrent`, {
      method: "POST",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  promisedPaymentStatus = async (id) => {
    let response = await fetch(`api/cards/${id}/promises`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  promisedPayment = async (id, activate) => {
    let form = new URLSearchParams();
    form.append("activate", activate);

    let response = await fetch(`api/cards/${id}/promises`, {
      method: "POST",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };
}

export class TV {
  constructor() {}

  tvs = async (limit, offset, date, total) => {
    let response = await fetch(
      date === "now"
        ? `api/tvs?limit=${limit}&offset=${offset}&total=${total}`
        : `api/tvs?limit=${limit}&offset=${offset}&date=${date}&total=${total}`,
      {
        method: "GET",
      }
    );
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  tvChannels = async () => {
    let response = await fetch("api/tvs/channels", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  tvCategories = async () => {
    let response = await fetch("api/tvs/categories", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  channelCategories = async () => {
    let response = await fetch("api/tvs/channels/categories", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  channelScheme = async (channel_id, date) => {
    let response = await fetch(
      `api/tvs/channels/${channel_id}/scheme?&date=${date}`,
      {
        method: "GET",
      }
    );
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  channel = async (channel_id) => {
    let response = await fetch(`api/tvs/channels/${channel_id}`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  program = async (programm_id) => {
    let response = await fetch(`api/tvs/programs/${programm_id}`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  calendar = async () => {
    let response = await fetch("api/tvs/calendar", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  tariffs = async () => {
    let response = await fetch("api/tariffs", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  services = async () => {
    let response = await fetch("api/services", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };
}

export class News {
  constructor() {}

  newsList = async (type_id, limit, offset) => {
    let response = await fetch(
      `api/news?type_id=${type_id}&limit=${limit}&offset=${offset}`,
      {
        method: "GET",
      }
    );
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };
}

export class Payment {
  constructor() {}

  payments = async (card_id) => {
    let response = await fetch(`api/payments?card_id=${card_id}`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  createPayment = async (code, amount, card_id, url_fail, url_return) => {
    let form = new URLSearchParams();
    form.append("amount", amount);
    form.append("card_id", card_id);
    form.append("url_fail", url_fail);
    form.append("url_return", url_return);

    let response = await fetch(`api/payments/${code}`, {
      method: "POST",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };
}

export class Feedback {
  constructor() {}

  feedback = async (
    property_quality,
    property_callback_time,
    property_was_useful,
    property_operator_benevolence,
    property_appeal_day,
    property_appeal_time,
    property_appeal_phone,
    property_operators_name,
    property_communicated_with,
    property_detail_text,
    property_personal_data_agreement
  ) => {
    let form = new URLSearchParams();
    form.append("property_quality", property_quality);
    form.append("property_callback_time", property_callback_time);
    form.append("property_was_useful", property_was_useful);
    form.append("property_operator_benevolence", property_operator_benevolence);
    form.append("property_appeal_day", property_appeal_day);
    form.append("property_appeal_time", property_appeal_time);
    form.append("property_appeal_phone", property_appeal_phone);
    form.append("property_operators_name", property_operators_name);
    form.append("property_communicated_with", property_communicated_with);
    form.append("property_detail_text", property_detail_text);
    form.append(
      "property_personal_data_agreement",
      property_personal_data_agreement
    );

    let response = await fetch("api/feedback/grade", {
      method: "POST",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  callback = async (source_id, type, name, mobile) => {
    let form = new URLSearchParams();
    form.append("name", name);
    form.append("mobile", mobile);

    let response = await fetch(`api/callback/${source_id}/${type}`, {
      method: "POST",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  tkoAction = async (
    abonent_name,
    abonent_mobile,
    abonent_email,
    agree_personal,
    agree_action499,
    agree_offer
  ) => {
    let form = new URLSearchParams();
    form.append("abonent_name", abonent_name);
    form.append("abonent_mobile", abonent_mobile);
    form.append("abonent_email", abonent_email);
    form.append("agree_personal", agree_personal);
    form.append("agree_action499", agree_action499);
    form.append("agree_offer", agree_offer);

    let response = await fetch("api/feedback/actions/tko_action_1rubl", {
      method: "POST",
      body: form,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  telekartaOnline = async (card_id) => {
    let response = await fetch(`api/check-online-register?card_id=${card_id}`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };
}

export class Favorites {
  constructor() {}

  favorites = async () => {
    let response = await fetch("api/tvs/favorites", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  addToFavorites = async (type, id) => {
    let response = await fetch(`api/tvs/favorites/${type}/${id}`, {
      method: "POST",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  removeFromFavorites = async (type, id) => {
    let response = await fetch(`api/tvs/favorites/${type}/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };
}

export class Notification {
  constructor() {}

  notificationList = async () => {
    let response = await fetch("api/notifications", {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };

  readNotification = async (id) => {
    let response = await fetch(`api/notifications/${id}`, {
      method: "PUT",
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return await response.json();
  };
}

export const user = new User();
export const cards = new Cards();
export const tv = new TV();
export const news = new News();
export const payment = new Payment();
export const feedback = new Feedback();
export const favorites = new Favorites();
export const notification = new Notification();
